module.exports = __webpack_public_path__ + "static/kazuha-5580300d9c4f5fc65bba7ab099a3c8c4.png";